import { render, staticRenderFns } from "./form-check.vue?vue&type=template&id=b8328bec&scoped=true"
import script from "./form-check.vue?vue&type=script&setup=true&lang=js"
export * from "./form-check.vue?vue&type=script&setup=true&lang=js"
import style0 from "./form-check.vue?vue&type=style&index=0&id=b8328bec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8328bec",
  null
  
)

export default component.exports